import { render, staticRenderFns } from "./CardRegistrosRepetidos.vue?vue&type=template&id=5534189a&scoped=true"
import script from "./CardRegistrosRepetidos.vue?vue&type=script&lang=js"
export * from "./CardRegistrosRepetidos.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosRepetidos.vue?vue&type=style&index=0&id=5534189a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534189a",
  null
  
)

export default component.exports